import { ProductListComponent } from './product-list/product-list.component';
export var productRoutes = [
    {
        path: 'product',
        data: {
            'expectedRoles': ['Admin', 'IT', 'Accountant', 'Accountant Admin', 'UIH', 'IT Admin', 'Finance Admin']
        },
        children: [
            {
                path: 'list',
                component: ProductListComponent,
                data: {
                    'expectedRoles': ['Admin', 'IT Admin', 'Finance Admin', 'Accountant', 'Accountant Admin', 'IT']
                },
            },
            {
                path: 'manage',
                component: ProductListComponent,
                data: {
                    'expectedRoles': ['Admin', 'IT Admin', 'Finance Admin', 'Accountant', 'Accountant Admin', 'IT']
                },
            }
        ],
    }
];
var ProductRoutingModule = (function () {
    function ProductRoutingModule() {
    }
    return ProductRoutingModule;
}());
export { ProductRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/product/product-routing.module.ts.pre-build-optimizer.js